/**
 * The currently required action
 *
 * @public
 */
export enum RequiredAction {
	/**
	 * An address document is required. Currently capturing for the first time.
	 */
	ADDRESSDOCUMENT_FIRST_SCAN = 'ADDRESSDOCUMENT',
	/**
	 * An address document is required. Currently capturing for the second time.
	 */
	ADDRESSDOCUMENT_SECOND_SCAN = 'ADDRESSDOCUMENT:SECONDSCAN',
	/**
	 * An address document is required. Currently capturing for the third time.
	 */
	ADDRESSDOCUMENT_THIRD_SCAN = 'ADDRESSDOCUMENT:THIRDSCAN',
	/**
	 * The back side of an identity document is required. Currently capturing
	 * for the first time.
	 */
	BACKSIDE_FIRST_SCAN = 'BACKSIDE',
	/**
	 * The back side of an identity document is required. Currently capturing
	 * for the second time.
	 */
	BACKSIDE_SECOND_SCAN = 'BACKSIDE:SECONDSCAN',
	/**
	 * The back side of an identity document is required. Currently capturing
	 * for the third time.
	 */
	BACKSIDE_THIRD_SCAN = 'BACKSIDE:THIRDSCAN',
	/**
	 * A self portrait image is required. Currently capturing for the first
	 * time.
	 */
	SELFIE_FIRST_SCAN = 'SELFIE',
	/**
	 * A self portrait image is required. Currently capturing for the second
	 * time.
	 */
	SELFIE_SECOND_SCAN = 'SELFIE:SECONDSCAN',
	/**
	 * A self portrait image is required. Currently capturing for the third
	 * time.
	 */
	SELFIE_THIRD_SCAN = 'SELFIE:THIRDSCAN',
	/**
	 * The front side of an identity document is required. Currently capturing
	 * for the first time.
	 */
	FRONTSIDE_FIRST_SCAN = 'FRONTSIDE',
	/**
	 * The front side of an identity document is required. Currently capturing
	 * for the second time.
	 */
	FRONTSIDE_SECOND_SCAN = 'FRONTSIDE:SECONDSCAN',
	/**
	 * The front side of an identity document is required. Currently capturing
	 * for the third time.
	 */
	FRONTSIDE_THIRD_SCAN = 'FRONTSIDE:THIRDSCAN',
	/**
	 * A liveness capture is required.
	 */
	LIVENESS = 'LIVENESS',
	/**
	 * Passive liveness capture is required.
	 */
	PASSIVE_LIVENESS = 'PASSIVE_LIVENESS',
	/**
	 * There is currently no required action.
	 */
	/**
	 * A covid document is required. Currently capturing for the first time.
	 */
	COVIDPASS_FIRST_SCAN = 'COVIDPASS',
	/**
	 * A covid document is required. Currently capturing for the second time.
	 */
	COVIDPASS_SECOND_SCAN = 'COVIDPASS:SECONDSCAN',
	/**
	 * A covid document is required. Currently capturing for the third time.
	 */
	COVIDPASS_THIRD_SCAN = 'COVIDPASS:THIRDSCAN',
	/**
	 * Confido project, CIFAS & ID3 API calls step
	 */
	DATACHECKS = 'DATACHECKS',
	NONE = 'NONE',
}
